import { format } from "date-fns";

const DateHelper = {
    getCurrentDate: function (): string {
        let newDate = new Date()
        if (isNaN(newDate.getTime()))
            return ""
        let date = newDate.getDate();
        let month = newDate.getMonth();
        let year = newDate.getFullYear();

        return format(new Date(year, month, date), 'MM/dd/yyyy');
    },

    getCurrentTime: function (): string {
        const locale = 'en';
        let newDate = new Date();
        return newDate.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric' });
    },

    getMonthName: function (month: number) {
        return Intl.DateTimeFormat('en', { month: 'long' }).format(new Date(`${month}`));
    },

    getFormattedDate: function (
        d: string | Date | null = null,
        dateFormat: string = 'dd/MM/yyyy',
    ) {
        const newDate = d ? new Date(d) : new Date();
        if (isNaN(newDate.getTime()))
            return ""
        // let date = newDate.getDate();
        // let month = newDate.getMonth();
        // const year = newDate.getFullYear();

        // const dateProps = new Date(year, month, date);

        if(dateFormat == 'dd Month, yyyy') {
            let date = newDate.getDate().toString().padStart(2, "0");
            let month = this.getMonthName(newDate.getMonth() + 1);
            const year = newDate.getFullYear();

            return date + " " + month + ", " + year;
        }

        return format(newDate, dateFormat);
    },

    getFormattedDateRange: function (
        startDate: string | Date | null | undefined,
        endDate: string | Date | null | undefined
    ): string {
        return (startDate && endDate ?
            (this.getFormattedDate(startDate, 'dd/MM/yyyy') + " - " + this.getFormattedDate(endDate, 'dd/MM/yyyy'))
            : this.getCurrentDate())
    },

    getWeekDayName: function (day: number, isFullName: boolean = false): string {
        const weekDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        const shortNames = weekDayNames.map(name => name.slice(0, 3));
        return isFullName ? weekDayNames[day - 1] : shortNames[day - 1];
    },
}
export default DateHelper;